"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PlaylistExecutionStage;
(function (PlaylistExecutionStage) {
    PlaylistExecutionStage["PlayingCurrentExercise"] = "PLAYING_CURRENT_EXERCISE";
    PlaylistExecutionStage["ShowingCurrentExerciseResultFeedback"] = "SHOWING_CURRENT_EXERCISE_RESULT_FEEDBACK";
    PlaylistExecutionStage["ShowingEndOfInitialTestMessage"] = "SHOWING_END_OF_INITIAL_TEST_MESSAGE";
})(PlaylistExecutionStage || (PlaylistExecutionStage = {}));
exports.default = PlaylistExecutionStage;
